// Histórico de mudanças mostrado ao clicar na versão (rodapé do menu).
//
// REGRA DO PROJETO: toda publicação que muda alguma coisa para quem usa ganha uma entrada
// aqui (mesmo padrão do Vencedores/GEDDOC). Uma entrada por data, da mais recente para a mais
// antiga. Texto de CLIENTE: o que ele vê e faz, sem nome de arquivo, tabela ou rota.
//
// tipo: 'novo' (não existia), 'melhoria' (já existia e ficou melhor) ou 'correcao' (estava
// errado e foi arrumado). `modulo` é a tela onde a mudança aparece.

export const HISTORICO = [
  {
    data: '2026-10-26',
    titulo: 'Proteção Veicular completa dentro do escritório',
    itens: [
      { tipo: 'novo', modulo: 'Proteção Veicular', texto: 'Nova área com as abas Início, Cotações, Contratos, Vistorias e Ganhos, com os dados reais da operação oficial. Cada licenciado vê só os seus clientes.' },
      { tipo: 'novo', modulo: 'Proteção Veicular', texto: 'Nova Cotação abre o formulário oficial dentro do escritório, com botões para copiar o link, enviar no WhatsApp e gerar QR Code.' },
      { tipo: 'novo', modulo: 'Proteção Veicular', texto: 'Cotações separadas em Leads, Arquivados e Adesões, com indicadores de leads e negociações em andamento. Ações: abrir, compartilhar com o cliente, registrar negociação ganha ou perdida, arquivar e recuperar.' },
      { tipo: 'novo', modulo: 'Proteção Veicular', texto: 'Ganha, perdida, arquivar e recuperar ficam marcados como "registro local, não sincronizado" até a operação oficial liberar a sincronização. O status oficial sempre prevalece e esse registro não gera comissão.' },
      { tipo: 'novo', modulo: 'Proteção Veicular', texto: 'Contratos: cliente e veículo, número, data, situação da proposta e da ativação, vigência, pendências, faturas e histórico de atualizações.' },
      { tipo: 'novo', modulo: 'Proteção Veicular', texto: 'Vistorias: datas, situação, pendências, resultado e orientação do próximo passo, com o link da vistoria para enviar ao cliente.' },
      { tipo: 'novo', modulo: 'Proteção Veicular', texto: 'Ganhos usa a carteira do escritório: comissão de adesão quando a adesão é paga e recorrência a cada mensalidade paga, pelo Plano de Negócios. Cada fatura gera comissão uma única vez.' },
      { tipo: 'melhoria', modulo: 'Proteção Veicular', texto: 'O fluxo comercial antigo (Minhas Vendas com cadastro, documentos e proposta manuais) foi retirado. Tudo segue agora o fluxo da operação oficial.' },
    ],
  },
  {
    data: '2026-10-21',
    titulo: 'Proteção Veicular com link de cotação de cada licenciado',
    itens: [
      { tipo: 'novo', modulo: 'Proteção Veicular', texto: 'Nova Cotação agora mostra o link de cotação do licenciado (protecao.theconect.com.br/cotacao/...). O cliente informa o veículo, vê o valor real da mensalidade e a cotação já fica no nome do licenciado. Botões para copiar, abrir e enviar direto no WhatsApp do cliente.' },
      { tipo: 'novo', modulo: 'Proteção Veicular', texto: 'Lista "Cotações feitas no seu link": cliente, veículo, placa, valor FIPE, mensalidade, adesão, data e situação (pendente, enviada, contratada, expirada ou recusada). Cada licenciado vê só as suas.' },
      { tipo: 'melhoria', modulo: 'Proteção Veicular', texto: 'A cotação interna com planos "Sob cotação" foi substituída pelo link oficial, que já calcula o valor pela FIPE do veículo.' },
      { tipo: 'novo', modulo: 'Geral', texto: 'Histórico de atualizações: clique na versão no rodapé do menu para ver o que mudou em cada publicação, com busca e filtro por novidades, melhorias e correções.' },
    ],
  },
  {
    data: '2026-10-20',
    titulo: 'Integração com a LabelView em produção',
    itens: [
      { tipo: 'novo', modulo: 'Proteção Veicular', texto: 'Integração com a LabelView ligada em produção: planos, cotações e faturas reais.' },
      { tipo: 'novo', modulo: 'Proteção Veicular', texto: 'Cada licenciado com licença ativa ganhou um consultor na LabelView com link de cotação próprio. Licenciados novos ganham o seu automaticamente quando a licença é ativada.' },
    ],
  },
  {
    data: '2026-08-26',
    titulo: 'Telecom: 1ª mensalidade pela The Conect e confirmação automática',
    itens: [
      { tipo: 'novo', modulo: 'Telecom', texto: 'A 1ª mensalidade de Ativação e Portabilidade passa a ser paga à The Conect por PIX (QR Code e copia e cola na tela). As mensalidades seguintes ficam com a operadora.' },
      { tipo: 'novo', modulo: 'Telecom', texto: 'Pagamento confirmado automaticamente: assim que o cliente paga, a venda é confirmada, gera pontos e comissões e a ativação na operadora é disparada, sem precisar clicar em "Verificar pagamento".' },
      { tipo: 'novo', modulo: 'Telecom', texto: 'Campo Chip (ICCID) com botão "Buscar estoque", que puxa um chip disponível automaticamente; também dá para digitar.' },
      { tipo: 'novo', modulo: 'Telecom', texto: 'Escolha de Pessoa Física ou Jurídica no formulário (o campo vira CPF ou CNPJ).' },
      { tipo: 'novo', modulo: 'Telecom', texto: 'CEP com busca automática: ao digitar, preenche endereço, cidade e UF.' },
      { tipo: 'novo', modulo: 'Parâmetros', texto: 'Opção para cobrar o chip junto na 1ª mensalidade, com valor configurável. Desligado, cobra só o plano.' },
      { tipo: 'correcao', modulo: 'Telecom', texto: 'Vendas de teste que ficaram com falha foram canceladas; a lista mostra só os pedidos válidos.' },
    ],
  },
  {
    data: '2026-08-18',
    titulo: 'Telecom: novo fluxo de venda',
    itens: [
      { tipo: 'melhoria', modulo: 'Telecom', texto: 'Nova venda: escolha entre Ativação ou Portabilidade e, em seguida, o plano. A compra de chip saiu desse fluxo e vai para a Loja.' },
      { tipo: 'melhoria', modulo: 'Telecom', texto: 'Planos com cor própria e preço na hora de escolher, para facilitar a identificação.' },
      { tipo: 'correcao', modulo: 'Telecom', texto: 'O valor do plano não era registrado na venda. Corrigido.' },
    ],
  },
  {
    data: '2026-08-06',
    titulo: 'Tema claro/escuro, recebimentos e correção de acesso',
    itens: [
      { tipo: 'novo', modulo: 'Geral', texto: 'Seletor de tema no topo e no menu do usuário: Claro, Escuro ou Auto.' },
      { tipo: 'novo', modulo: 'Geral', texto: 'Menu do usuário no canto superior direito com dados da conta, Minha conta, tema e Sair.' },
      { tipo: 'novo', modulo: 'Painel', texto: 'Card "Total Movimentado Asaas" com a lista de recebimentos paginada, e o quadro "Últimos recebimentos ASAAS" (recebido ou registrado para cobrança).' },
      { tipo: 'correcao', modulo: 'Acesso', texto: 'Licenciados que já tinham pagado estavam vendo o aviso de licença não ativada. Corrigido: o sistema confere o status real da licença ao entrar.' },
      { tipo: 'correcao', modulo: 'Extrato', texto: 'Pontos (PV) e a referência de origem não apareciam nos bônus de expansão do extrato. Corrigido em toda a rede.' },
    ],
  },
]

function semAcento(s) {
  return String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
}

export function dataBR(iso) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(iso || ''))
  return m ? `${m[3]}/${m[2]}/${m[1]}` : String(iso || '')
}

/** Filtra por texto digitado e por tipo ('all' | 'novo' | 'melhoria' | 'correcao'). */
export function filtrarHistorico(historico, busca = '', tipo = 'all') {
  const lista = Array.isArray(historico) ? historico : []
  const termos = semAcento(busca).trim().split(/\s+/).filter(Boolean)
  const soTipo = tipo && tipo !== 'all' ? tipo : null
  const saida = []
  for (const entrada of lista) {
    const cabecalho = `${semAcento(entrada.titulo)} ${dataBR(entrada.data)}`
    const itens = (entrada.itens || []).filter((it) => {
      if (soTipo && it.tipo !== soTipo) return false
      if (!termos.length) return true
      const alvo = `${cabecalho} ${semAcento(it.texto)} ${semAcento(it.modulo)}`
      return termos.every((t) => alvo.includes(t))
    })
    if (itens.length) saida.push({ ...entrada, itens })
  }
  return saida
}

/** Quantos itens de cada tipo existem (para os contadores dos filtros). */
export function contarPorTipo(historico = HISTORICO) {
  const c = { all: 0, novo: 0, melhoria: 0, correcao: 0 }
  for (const e of historico || []) {
    for (const it of e.itens || []) {
      c.all += 1
      c[it.tipo] = (c[it.tipo] || 0) + 1
    }
  }
  return c
}
